import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import { Icon, Tooltip } from 'src/components';
import theme from 'src/utils/theme';
import * as S from './styles';

const msgs = defineMessages({
  requestVideo: {
    id: 'learning_session_request_video',
    defaultMessage: 'Request a video',
  },
  videoRequested: {
    id: 'learning_session_video_requested',
    defaultMessage: 'Video requested',
  },
  videoRequestedTooltip: {
    id: 'learning_session_video_requested_tooltip',
    defaultMessage:
      "Our team has been notified to shoot a video for this word. We'll notify you when it is added",
  },
});

export interface RequestVideoButtonProps {
  requested: boolean;
  onToggle: () => void;
}

export const RequestVideoButton: FC<RequestVideoButtonProps> = ({ requested, onToggle }) => {
  const intl = useIntl();
  const isMobile = useMediaQuery({ maxWidth: theme.sz.md });
  const label = intl.formatMessage(requested ? msgs.videoRequested : msgs.requestVideo);
  const tooltipLabel = intl.formatMessage(msgs.videoRequestedTooltip);

  return (
    <Tooltip placement="bottom" tooltip={tooltipLabel} disabled={isMobile || !requested}>
      <S.Button
        type="button"
        aria-label={label}
        aria-pressed={requested}
        onClick={onToggle}
        data-testid="request-video-button"
      >
        <Icon name={requested ? 'check' : 'videoRequest'} />
        {label}
      </S.Button>
    </Tooltip>
  );
};
